/* ---------------------------------------------------------------------------
   Wrapped in an IIFE and every customElements.define() guarded, because this
   file is now loaded from TWO places: snippets/halo-cart-sidebar.liquid (the
   drawer) and sections/main-cart.liquid (the cart page). Ella does not render
   the drawer on the cart template today, but if that ever changes a second
   execution would otherwise throw - top-level `class` declarations are lexical
   bindings and cannot be redeclared, and define() throws on a repeated name.
--------------------------------------------------------------------------- */
(function () {
class CartTool extends HTMLElement{constructor(){super();const buttons=this.querySelectorAll('.cartTool-item');buttons.forEach((button)=>{button.addEventListener('click',(event)=>{const id=event.target.dataset.popup;document.getElementById(id).classList.add('show');document.querySelector('.previewCart').classList.add('active-tool')})})}}
if(!customElements.get('cart-item-tool'))customElements.define('cart-item-tool',CartTool);class CartCancel extends HTMLElement{constructor(){super();this.querySelector('button').addEventListener('click',(event)=>{document.querySelector('.popup-toolDown.show').classList.remove('show');document.querySelector('.previewCart').classList.remove('active-tool')})}}
if(!customElements.get('cart-cancel-popup'))customElements.define('cart-cancel-popup',CartCancel);class CartNote extends HTMLElement{constructor(){super();this.querySelector('[data-update-note]').addEventListener('click',(event)=>{this.val=this.querySelector('.text-area').value;const body=JSON.stringify({note:this.val});fetch(`${routes.cart_update_url}`,{...fetchConfig(),...{body}});document.querySelector('.popup-toolDown.show').classList.remove('show');document.querySelector('.previewCart').classList.remove('active-tool')})}}
if(!customElements.get('cart-note'))customElements.define('cart-note',CartNote);
/* ---------------------------------------------------------------------------
   BB REWRITE of <coupon-code>  (2026-09-08)

   WHY: the original constructor did
        if(localStorage.getItem('storedDiscount')){ input.value = storedDiscount }
   and nothing anywhere ever removed that key. halo.updateSidebarCart() re-renders
   the whole drawer on every add-to-cart / qty change, so the element is rebuilt
   and the constructor re-runs - which is why a code the customer had removed
   reappeared in the field by itself.

   The cart is now the single source of truth: data-applied-code is written by
   Liquid from cart.cart_level_discount_applications, and localStorage is only
   ever a mirror of it.

   Apply/remove now go through POST /cart/update.js {discount:"CODE"|""}
   (Cart AJAX API, discount support GA since 2025-05). /discount/CODE is kept
   only as a fallback if that endpoint refuses, because /discount/ can add a
   code but has no documented way to clear one.
--------------------------------------------------------------------------- */
class CouponCode extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="discount"]');
    this.msg = this.querySelector('[data-coupon-message]');
    this.applied = (this.getAttribute('data-applied-code') || '').trim();
    this.busy = false;

    try {
      if (this.applied) { localStorage.setItem('storedDiscount', this.applied); }
      else { localStorage.removeItem('storedDiscount'); }
    } catch (e) {}

    /* SELF-HEAL: wipe a code the customer never typed.
       TBBS500 is the ONLY discount code in this store - every bundle offer is an
       AUTOMATIC discount with no code at all - so any code sitting on the cart is
       legitimate only if this browser applied it through this field. Shopify keeps
       a code attached across cart clears and across sessions, so one left over
       from an earlier visit (or from a /discount/ link) re-applies itself the
       moment the subtotal crosses the minimum, with no customer action.

       localStorage is the ownership record. If it cannot be read, we do NOTHING -
       otherwise the wipe would fire on the very reload that follows a successful
       apply and fight the customer in a loop. */
    if (this.applied && CouponCode.storageWorks() && !this.isOwned(this.applied)) {
      this.disown(); this.wipe();
    }

    if (this.input && !this.applied && this.input.type !== 'hidden') { this.input.value = ''; }

    const save = this.querySelector('[data-update-coupon]');
    if (save) {
      save.addEventListener('click', () => this.submit(this.input ? this.input.value.trim() : ''));
    }
    if (this.input && this.input.type !== 'hidden') {
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); this.submit(this.input.value.trim()); }
      });
      /* Apply stays grey until something is typed - same affordance as Shopify's
         own checkout field, so the button never looks clickable while it is a
         no-op. Class toggled here rather than styled with :placeholder-shown
         because the button is a sibling of the input, not a descendant. */
      this.row = this.querySelector('.bb-coupon-row');
      const mark = () => {
        if (!this.row) return;
        this.row.classList.toggle('has-value', this.input.value.trim() !== '');
      };
      this.input.addEventListener('input', mark);
      mark();
    }
    const remove = this.querySelector('[data-remove-coupon]');
    if (remove) { remove.addEventListener('click', () => this.submit('')); }
  }

  static storageWorks() {
    try {
      const k = '__bb_probe__';
      localStorage.setItem(k, '1');
      localStorage.removeItem(k);
      return true;
    } catch (e) { return false; }
  }

  isOwned(code) {
    try {
      const owned = localStorage.getItem('bbCouponOwned') || '';
      return owned.trim().toUpperCase() === String(code).trim().toUpperCase();
    } catch (e) { return true; }
  }

  own(code) { try { localStorage.setItem('bbCouponOwned', code); } catch (e) {} }

  disown() { try { localStorage.removeItem('bbCouponOwned'); } catch (e) {} }

  /* Strip the cart's discount without any UI churn, then repaint. */
  async wipe() {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: '' })
      });
      await this.refresh();
    } catch (e) {}
  }

  say(text) {
    if (!this.msg) return;
    if (text) { this.msg.textContent = text; this.msg.hidden = false; }
    else { this.msg.textContent = ''; this.msg.hidden = true; }
  }

  done() { this.busy = false; this.classList.remove('is-loading'); }

  async submit(code) {
    if (this.busy) return;
    if (code === '' && this.applied === '') { return; }
    this.busy = true;
    this.classList.add('is-loading');
    this.say('');

    const invalid = this.getAttribute('data-error-text') || 'This code is not valid for your cart.';

    try {
      let ok = false;
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: code })
      });
      ok = res.ok;

      /* fallback for shops where /cart/update.js rejects the discount param */
      if (!ok && code) {
        try { await fetch('/discount/' + encodeURIComponent(code)); ok = true; } catch (e) {}
      }

      const cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
      const live = (cart.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);

      try {
        if (live.length) { localStorage.setItem('storedDiscount', live[0]); }
        else { localStorage.removeItem('storedDiscount'); }
      } catch (e) {}

      /* record / release ownership - this is what tells the next page load that
         the customer typed this code themselves */
      if (live.length) { this.own(live[0]); } else { this.disown(); }

      /* CRITICAL: a code that does not currently qualify is still ATTACHED to the
         cart by Shopify, sitting there as {code:"TBBS500", applicable:false}. It
         costs nothing while the cart is below the minimum - and then applies
         ITSELF the moment the customer adds enough to cross it, with no action
         from them. Verified on the live cart. So a rejected code must be wiped
         off the cart immediately, not just reported. */
      if (code && live.length === 0) {
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: '' })
          });
        } catch (e2) {}
        this.say(invalid);
        this.done();
        return;
      }

      await this.refresh();
    } catch (e) {
      this.say(invalid);
      this.done();
    }
  }

  /* Repaint the drawer in place. NOT via halo.updateSidebarCart(): `halo` is
     declared `var halo = …` INSIDE theme.js's `(function($){ … })` wrapper, so it
     is never exposed on window and any check for it fails - which is why the
     first build fell through to location.reload() and the whole page flashed on
     every Apply. This does exactly what updateSidebarCart does: re-render the
     ajax_side_cart view into .previewCart-wrapper and fire the change event that
     the free-shipping bar listens for.

     jQuery's .html() is preferred over innerHTML because halo-side-cart.liquid
     emits an inline <script> per line item (window.cart_selling_array_*), and
     innerHTML does not execute injected scripts - jQuery does. */
  async refresh() {
    if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }

    const target = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    if (!target) { window.location.reload(); return; }

    const root = (window.routes && window.routes.root) ? window.routes.root : '';

    try {
      const html = await (await fetch(root + '/cart?view=ajax_side_cart', { headers: { 'Accept': 'text/html' } })).text();
      if (window.jQuery) { window.jQuery(target).html(html); }
      else { target.innerHTML = html; }
      document.querySelectorAll('[data-free-shipping-wrapper]').forEach((el) => {
        el.dispatchEvent(new Event('change', { bubbles: true }));
      });
    } catch (e) {
      window.location.reload();
    }
  }
}
if(!customElements.get('coupon-code'))customElements.define('coupon-code',CouponCode)
})();
